import { render, staticRenderFns } from "./TopQuestions.vue?vue&type=template&id=7ced0b2b"
import script from "./TopQuestions.vue?vue&type=script&lang=js"
export * from "./TopQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports